import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function MoreCircle({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <MoreCircle.Outline {...props} />
  ) : (
    <MoreCircle.Solid {...props} />
  );
}

MoreCircle.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M15.9395 11.0129C15.3872 11.0129 14.9395 11.4607 14.9395 12.0129C14.9395 12.5652 15.3872 13.0129 15.9395 13.0129H15.9485C16.5007 13.0129 16.9485 12.5652 16.9485 12.0129C16.9485 11.4607 16.5007 11.0129 15.9485 11.0129H15.9395Z"
          fill="currentColor"
        />
        <path
          d="M10.9304 12.0129C10.9304 11.4607 11.3781 11.0129 11.9304 11.0129H11.9394C12.4917 11.0129 12.9394 11.4607 12.9394 12.0129C12.9394 12.5652 12.4917 13.0129 11.9394 13.0129H11.9304C11.3781 13.0129 10.9304 12.5652 10.9304 12.0129Z"
          fill="currentColor"
        />
        <path
          d="M7.92139 11.0129C7.3691 11.0129 6.92139 11.4607 6.92139 12.0129C6.92139 12.5652 7.3691 13.0129 7.92139 13.0129H7.93039C8.48267 13.0129 8.93039 12.5652 8.93039 12.0129C8.93039 11.4607 8.48267 11.0129 7.93039 11.0129H7.92139Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0002 2C6.47803 2 2.00024 6.47779 2.00024 12C2.00024 17.5222 6.47698 22 12.0002 22C17.5225 22 22.0002 17.5222 22.0002 12C22.0002 6.47673 17.5224 2 12.0002 2ZM3.50024 12C3.50024 7.30621 7.30646 3.5 12.0002 3.5C16.6941 3.5 20.5002 7.30527 20.5002 12C20.5002 16.6938 16.694 20.5 12.0002 20.5C7.30551 20.5 3.50024 16.6938 3.50024 12Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

MoreCircle.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
